import { Button, Dialog, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const ButtonRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'column-reverse',
  gap: theme.spacing(2),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(3)} !important`,

  [theme.breakpoints.up('sm')]: {
    padding: `${theme.spacing(4)} !important`,
  },
}));

export const ConfirmNumberDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.spacing(4),
    padding: theme.spacing(6),
    width: '100%',
    margin: theme.spacing(0, 6),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(8),
      margin: 0,
    },
  },
}));

export const DialogHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.primary.main,
}));

export const MobileNumber = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(5),
}));
